import type { NewsroomGallery } from '@prezly/sdk';
import { getGalleryThumbnail } from '@prezly/theme-kit-core';
import { useGetLinkLocaleSlug } from '@prezly/theme-kit-nextjs';
import classNames from 'classnames';
import Link from 'next/link';

import { GalleryCardThumbnail } from '@/components/GalleryCard/GalleryCardThumbnail';
import { IconArrowRight } from '@/icons';
import { ButtonLink } from '@/ui';

import styles from './GalleryCard.module.scss';

interface Props {
    className?: string;
    gallery: NewsroomGallery;
}

function GalleryCard({ className, gallery }: Props) {
    const { name, uuid } = gallery;
    const galleryThumbnail = getGalleryThumbnail(gallery);
    const getLinkLocaleSlug = useGetLinkLocaleSlug();

    return (
        <div className={classNames(styles.container, className)}>
            {galleryThumbnail && (
                <Link href={`/media/album/${uuid}`} locale={getLinkLocaleSlug()}>
                    <GalleryCardThumbnail
                        className={styles.thumbnail}
                        imageDetails={galleryThumbnail}
                    />
                </Link>
            )}
            <div className={styles.content}>
                <Link
                    href={`/media/album/${uuid}`}
                    locale={getLinkLocaleSlug()}
                    className={styles.title}
                >
                    {name}
                </Link>
                <ButtonLink
                    variation="secondary"
                    href={`/media/album/${uuid}`}
                    className={styles.button}
                    icon={IconArrowRight}
                    iconPlacement="right"
                >
                    {/* TODO: add translations for "view" */}
                    View
                </ButtonLink>
            </div>
        </div>
    );
}

export default GalleryCard;
